import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";
import { CANTIERE_STATUS, CANTIERE_TONE, fmtDate } from "@/lib/format";
import { Pill, ProgressBar } from "@/components/rp";

export const CantiereCard = ({ c }) => (
  <Link to={`/admin/cantieri/${c.id}`} data-testid={`cantiere-card-${c.id}`} className="group rp-card overflow-hidden flex flex-col hover:border-[#C8BDAB] transition-colors">
    <div className="relative h-44 bg-[#EBEBEB] overflow-hidden">
      <img src={fileUrl(c.cover_url) || "/login.jpg"} alt={c.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
      <div className="absolute top-3 left-3"><Pill tone={CANTIERE_TONE[c.status]}>{CANTIERE_STATUS[c.status]}</Pill></div>
    </div>
    <div className="p-5 flex-1 flex flex-col">
      <p className="rp-label">{c.client_name}</p>
      <p className="font-medium text-lg mt-1 leading-snug">{c.title}</p>
      <p className="text-sm text-[#757575] mt-1">{c.current_phase}</p>
      <div className="mt-auto pt-5">
        <div className="flex justify-between text-xs mb-2"><span className="text-[#757575]">Fine prevista {fmtDate(c.expected_end)}</span><span className="font-semibold">{c.progress}%</span></div>
        <ProgressBar value={c.progress} />
      </div>
    </div>
  </Link>
);
